<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  created () {
    console.log(this.$route.path)
    var path = this.$route.path
    if (path.includes("home") || path.includes("about") || path.includes("contact") || path.includes("news") || path.includes("assets")){
      console.log(true)
    }else{
      console.log(this.$route.path)
      console.log(false)
      this.$store.dispatch('reloadUserInfo')
    }
  }
}
</script>
<style scoped>
#app {
  position: relative;
  background-color: #FFFFFF;
  text-align: center;
  color: #2c3e50;
  min-width: 1300px;
  min-height:100%;
  margin: 0 auto;
}

</style>
